<template>
  <v-dialog v-model="value" persistent max-width="600px">
    <v-card>
      <v-toolbar dark dense color="primary">
        <v-toolbar-title>Preview Template</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="previewForm">
          <html-snippet-select v-model="emailTemplateFooterId" :show-preview="true"
            label="Select a footer to preview with" snippet-type-filter="EmailTemplateFooter" class="mt-6">
          </html-snippet-select>
          <rooftop-select v-model="rooftopId" :dealer-id="dealer.id" />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="$emit('input', false)">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="doPreview">
          Preview
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import HtmlSnippetSelect from '@/components/inputs/HtmlSnippetSelect'
import RooftopSelect from '@/components/inputs/RooftopSelect'
import { R4UtilsApi, EmailTemplateApi } from '@/services'
import { mapState } from 'vuex'

export default {
  name: 'preview-template-dialog',
  mixins: [],
  components: {
    [HtmlSnippetSelect.name]: HtmlSnippetSelect,
    [RooftopSelect.name]: RooftopSelect
  },
  props: {
    // value is bool - show or hide
    value: {
      required: true,
      type: Boolean,
      default: false
    },
    emailTemplateId: {
      required: false,
      type: [Number, String]
    },
    emailFooterId: {
      required: false,
      type: [Number, String]
    },
    showRawHtml: {
      required: false,
      type: Boolean,
      default: false
    },
    useLiveViewApi: {
      required: false,
      type: Boolean,
      default: false
    },
    htmlTemplate: {
      required: false,
      type: String
    },
    isCampaign: {
      required: false,
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      emailTemplateFooterId: null,
      rooftopId: null
    }
  },
  computed: {
    ...mapState('DealerStore', ['dealer']),
    previewFn() {
      if (this.useLiveViewApi) {
        this.$logger.trace('Using Live View')
        return EmailTemplateApi.getHtmlLiveView
      } else {
        this.$logger.trace('Using Preview View')
        return EmailTemplateApi.getHtmlPreview
      }
    }
  },
  watch: {
    emailFooterId: {
      handler(newVal, oldVal) {
        this.emailTemplateFooterId = newVal
      }
    },
    dealer: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal && newVal.id) {
          this.rooftopId = newVal.rooftops.find(r => r.default_rooftop).id
        }
      }
    }
  },
  methods: {
    doPreview() {
      if (!this.useLiveViewApi && !this.emailTemplateId) {
        alert('Email Template to preview (id) is not set')
        return
      } else if (this.useLiveViewApi && !this.htmlTemplate) {
        alert('Email Template to preview (live) is not set')
        return
      }
      this.previewFn({ rooftopId: this.rooftopId, emailTemplateId: this.emailTemplateId, emailTemplateFooterId: this.emailTemplateFooterId, htmlTemplate: this.htmlTemplate, rawHtml: this.showRawHtml, dealerId: this.dealer.id, isCampaign: this.isCampaign })
        .then((htmlTemplatePreview) => {
          R4UtilsApi.openHtmlInNewTab(htmlTemplatePreview.data.html);
        })
        .catch(error => {
          this.$flash({
            showClose: true,
            message: 'Error Loading Email Templates. Reload to try again.' + error.message,
            type: 'error',
            duration: 0
          })
        })

      // finally close thyself
      this.$emit('input', false)
    }
  }

}
</script>